import { THEMES, DEFAULT_THEME_ID } from "@starquest/core";
import type { Kid, ThemeConfig } from "@starquest/core";

export function useTheme(kid?: Kid | null): ThemeConfig {
  const id = kid?.theme ?? DEFAULT_THEME_ID;
  return THEMES[id] ?? THEMES[DEFAULT_THEME_ID];
}
